import { isArray, isNumber, isNumberEquals, isObject, removeUndefined, resolveFirst } from "@churchofjesuschrist/maps-utils";
import { degreeEqualsTolerance, degreeNearlyEqualsTolerance } from "@churchofjesuschrist/maps-constants";
export default class Position {
  static create(longitude, latitude, altitude) {
    return Position.toGeoJSON({
      longitude,
      latitude,
      altitude
    });
  }
  static toJSON(position) {
    if (isArray(position)) {
      let [longitude, latitude, altitude] = position;
      if (isNumber(longitude) && isNumber(latitude)) {
        return removeUndefined({
          longitude,
          latitude,
          altitude: isNumber(altitude) ? altitude : undefined
        });
      }
    } else if (isObject(position)) {
      if (isNumber(position.latitude) && isNumber(position.longitude)) {
        return position;
      } else {
        let longitude = resolveFirst(position, "longitude", "long", "lng", "x");
        let latitude = resolveFirst(position, "latitude", "lat", "y");
        let altitude = resolveFirst(position, "altitude", "alt", "elevation", "el", "z");
        if (isNumber(longitude) && isNumber(latitude)) {
          return removeUndefined({
            longitude,
            latitude,
            altitude: isNumber(altitude) ? altitude : undefined
          });
        }
      }
    }
    return null;
  }
  static toGeoJSON(position) {
    let pos = Position.toJSON(position);
    if (pos) {
      let geojson = [pos.longitude, pos.latitude];
      if (isNumber(pos.altitude)) {
        geojson.push(pos.altitude);
      }
      return geojson;
    }
    return null;
  }
  static toString(position) {
    let pos = Position.toJSON(position);
    return pos ? `${pos.latitude.toFixed(6)}, ${pos.longitude.toFixed(6)}` : null;
  }
  static isPosition(value) {
    return !!Position.toJSON(value);
  }
  static getLatitude(position) {
    let pos = Position.toJSON(position);
    return pos?.latitude;
  }
  static getLongitude(position) {
    let pos = Position.toJSON(position);
    return pos?.longitude;
  }
  static getAltitude(position) {
    let pos = Position.toJSON(position);
    return pos?.altitude;
  }
  static equals(position1, position2) {
    if (position1 === position2) {
      return true;
    }
    let pos1 = Position.toJSON(position1);
    let pos2 = Position.toJSON(position2);
    if (pos1 && pos2) {
      return isNumberEquals(pos1.latitude, pos2.latitude, degreeEqualsTolerance) && isNumberEquals(pos1.longitude, pos2.longitude, degreeEqualsTolerance) && (pos1.altitude === pos2.altitude || isNumberEquals(pos1.altitude || 0, pos2.altitude || 0, degreeEqualsTolerance));
    }
    return false;
  }
  static nearlyEquals(position1, position2) {
    if (position1 === position2) {
      return true;
    }
    let pos1 = Position.toJSON(position1);
    let pos2 = Position.toJSON(position2);
    if (pos1 && pos2) {
      return isNumberEquals(pos1.latitude, pos2.latitude, degreeNearlyEqualsTolerance) && isNumberEquals(pos1.longitude, pos2.longitude, degreeNearlyEqualsTolerance) && (pos1.altitude === pos2.altitude || isNumberEquals(pos1.altitude || 0, pos2.altitude || 0, degreeNearlyEqualsTolerance));
    }
    return false;
  }
}